<ng-container stagesSlot="main"></ng-container>
<router-outlet></router-outlet>
